import { BaseLink } from 'src/components/BaseLink';
import React from 'react';
import { TTabNavProps } from './TabNav.types';
import classnames from 'classnames';
import s from './TabNav.module.scss';

export const TabNav: React.FC<TTabNavProps> = ({ className, nav }) => {
  return (
    <nav className={classnames(s.tabsWrapper, className)}>
      {nav.map((item, index) => (
        <BaseLink
          key={index}
          className={s.tab}
          onClick={item.onClick}
          isActive={item.isActive}
          disabled={item.disabled}
          theme="2">
          {item.label}
        </BaseLink>
      ))}
    </nav>
  );
};
